module.exports = __webpack_public_path__ + "img/section1_tab2_img.a768f2a1.svg";